// Shared amenity code → icon name mapping for hotel UI
// Used by search cards, detail feature sections, etc.

export const HOTEL_AMENITY_ICON_MAP = {
  3: "circle-wifi",
  7: "pet-custom",
  8: "wheelchair-1",
  9: "circle-parking",
  11: "vault",
  13: "water-ladder-1-1",
  22: "child-hotel",
  23: "air-conditioner",
  27: "bus-service-1",
  28: "umbrella-beach-1",
  30: "hot-tub-person",
  39: "water-ladder-1-1",
  60: "water-ladder-1-1",
  85: "unlock-room",
  88: "cstm-smarttv",
  89: "custom-nespresso",
  107: "hotel-building-new",
  159: "person-swimming-child-1",
  186: "charging-station-1",
  247: "water",
  257: "spa-1",
  267: "shower",
  268: "shower",
  269: "bath",
  270: "hair-dryer",
  272: "mini-bar",
  292: "terrace-new",
  295: "leak-sea",
  296: "leak-sea",
  297: "tree",
  302: "airplane-otel",
  372: "mountbig",
  373: "blueflag",
  404: "tulip",
  563: "umbrella-beach-1",
  720: "circle-parking",
  721: "circle-parking",
  727: "circle-parking",
};

